import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as dayjs from 'dayjs';

@Component({
  selector: 'psc-consumption-input',
  templateUrl: './consumption-input.component.html',
})
export class ConsumptionInputComponent implements OnInit {

  @Input() showDialog: boolean;
  @Input() consumptionValues: number[];
  @Input() tariffHasTwoPrices: boolean = false;
  @Output() consumptionValuesSaved: EventEmitter<number[]> = new EventEmitter<number[]>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

  formGroup: FormGroup;
  months: string[] = dayjs.months();

  get consumptionArray(): FormArray {
    return this.formGroup.controls["consumptionArray"] as FormArray;
  }

  constructor(
    private formBuilder: FormBuilder,
  ) {
  }

  ngOnInit(): void {
    const numberOfInputs = this.tariffHasTwoPrices ? 24 : 12;
    const arrayValues = this.consumptionValues?.length === numberOfInputs ?
      this.consumptionValues.map(value => this.formBuilder.control(value, [Validators.required, Validators.min(0)])) :
      Array.from({ length: numberOfInputs }, () => this.formBuilder.control(null, [Validators.required, Validators.min(0)]));

    this.formGroup = this.formBuilder.group({
      consumptionArray: this.formBuilder.array(arrayValues),
    });
  }

  submit() {
    this.consumptionValuesSaved.emit(this.consumptionArray.value);
  }

  reset() {
    for (const control of this.consumptionArray.controls) {
      if(control.value) {
        control.setValue('');
      }
    }
    this.formGroup.updateValueAndValidity();
  }
}
